import {KOSubscriptionTracker} from "../../../util/KOSubscriptionTracker";
import {ErrorTracker} from "../../../error.tracker";
import {global} from "../../../appContext";
import {nsOverride} from "../../override/nsOverride";
import {AbstractSystemPermission} from "./AbstractSystemPermission";
import {ObjectTypeId} from "../../../constants";
import getTitleTextByOverride = nsOverride.getMoreStatusByOverride;

export interface IParams {
    sp: AbstractSystemPermission
}

export class PermissionRowAbstract {
    private readonly kosub: KOSubscriptionTracker = new KOSubscriptionTracker();
    private readonly showOverride = nsOverride.showOverride;
    protected readonly sp: AbstractSystemPermission;
    protected readonly errorTracker: ErrorTracker = global.errorAreas.get('permission.edit');

    constructor(protected params: IParams) {
        this.sp = params.sp;
    }

    private getTitle(): string {
        const override = this.sp.override();
        if (override) {
            return getTitleTextByOverride(override, ObjectTypeId.System).title;
        }
        return '';
    }

    dispose() {
        this.kosub.unsuscribeAll();
    }
}
